var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-grid',{attrs:{"theme":"material","source":_vm.data_table,"columns":_vm.columns,"resize":"true","columnTypes":_vm.columnTypes,"row-headers":"true","frameSize":"45"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }